import styles from './BillingInfoCard.module.scss'

const Root = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.card}>{children}</div>
}

const Header = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.header}>{children}</div>
}

const Title = ({ children }: { children: React.ReactNode }) => {
  return <p className={styles.title}>{children}</p>
}

const Subtitle = ({ children }: { children: React.ReactNode }) => {
  return <p className={styles.subtitle}>{children}</p>
}

const Body = ({ children }: { children: React.ReactNode }) => {
  return <p className={styles.body}>{children}</p>
}

const CTA = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.ctaContainer}>{children}</div>
}

export const BillingInfoCard = {
  Root,
  Header,
  Title,
  Subtitle,
  Body,
  CTA,
}
